import trim from "./trim";

/**
 * Converts a string to kebab-case.
 * Handles camelCase, PascalCase, and space-separated strings.
 *
 * @param value The string to convert
 * @returns A kebab-case formatted string
 */
export default function kebabCase(value: string): string {
	if (!value) return '';

	const withSpacesHandled = value.replace(/\s+/g, '-');
	const kebabString = withSpacesHandled
		.replace(/^([A-Z])/, (match) => match.toLowerCase())
		.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`);

	return trim(kebabString.replace(/-+/g, '-'), '-');
}
